import { SVGProps } from "react";

const STIJacobin = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-label="Jacobin" role="img" viewBox="0 0 512 512" width="1em" height="1em" {...props}><rect width={512} height={512} rx="15%" fill="#fff" /><path fill="none" stroke="#000" strokeWidth={34} d="m166 326a84 84 0 10170 0V124H158" /></svg>;

export { STIJacobin };